import { useFeatureIsOn } from 'src/common/growthbook';

export const useIsRemoveUsernameExperimentEnabled = () => useFeatureIsOn('remove-username-sign-up');
